var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperlinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hyperlinkIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    width: 24,
    height: 24,
    rx: 8,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    transform: "translate(150.14 -329.793) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M143.865,333A2.869,2.869,0,0,0,141,335.865v.651a.781.781,0,1,0,1.563,0v-.651a1.3,1.3,0,1,1,2.6,0v2.6a1.3,1.3,0,0,1-1.3,1.3.781.781,0,0,0,0,1.563,2.869,2.869,0,0,0,2.865-2.865v-2.6A2.869,2.869,0,0,0,143.865,333Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M143.865,374.336a2.869,2.869,0,0,0,2.865-2.865v-.651a.781.781,0,0,0-1.563,0v.651a1.3,1.3,0,0,1-2.6,0v-2.6a1.3,1.3,0,0,1,1.3-1.3.781.781,0,0,0,0-1.563A2.869,2.869,0,0,0,141,368.865v2.6A2.869,2.869,0,0,0,143.865,374.336Z",
    transform: "translate(0 -28.702)",
    fill: "#484848"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlinkIcon);
export default __webpack_public_path__ + "static/media/hyperlinkIcon.33be6e361105f9d625dc901ece1abc7d.svg";
export { ForwardRef as ReactComponent };